import { httpClient, httpClientCustom } from './../httpClient';
import { apiErrorHandler } from './helpers';
import { useCustomPaginatedQuery } from 'hooks/reactQuery';

// const SernsoftUrl = 'http://192.168.0.69:8006/api';
const SernsoftUrl = 'https://einvoice-api-stg.sernsoft.com/api';

export const eInvoiceEnrollment = body => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/register-api-user`, body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const eInvoiceHPEnrollment = body => {
  return httpClient
    .post(`/e-invoice/register`, body)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getPlanList = () => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .get('/external/subscriptions')
      .then(response => {
        return response;
      })
  );
};

export const getEinvoiceUser = hostId => {
  return httpClient
    .get('/e-invoice/get-account', {
      params: hostId ? { hostId } : {}
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getLinkProfileList = () => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .get('/external/profiles')
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const linkProfileForm = body => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/create-project`, body, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const getCreateInvoiceList = (projectId, startDate, endDate) => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .get(`/e-invoice?projectId=${projectId}&filter={"createdAt":{"$gte":"${startDate}","$lte":"${endDate}"}}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const getConsolidatedInvoiceList = (projectId, startDate, endDate, hostId) => {
  return httpClient
    .get(`/e-invoice/consolidated-invoice`, {
      params: {
        projectId,
        filter: JSON.stringify({ createdAt: { $gte: startDate, $lte: endDate } }),
        ...(hostId ? { hostId } : {})
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const reservationCreateEinvoice = body => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/e-invoice`, body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const createCustomerSelfServiceForm = body => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/e-invoice/customer-self-service-form`, body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const createConsolidatedInvoice = body => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post('/e-invoice/consolidated-invoice', body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const getConsolidatedInvoiceBookings = (invoiceId, { page = 1, limit = 50, hostId } = {}) => {
  return httpClient
    .get(`/e-invoice/consolidated-invoice/${invoiceId}/bookings`, {
      params: {
        page,
        limit,
        ...(hostId ? { hostId } : {})
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getConsolidatedInvoiceBookingsCsv = (invoiceId, hostId) => {
  return httpClient
    .get(`/e-invoice/consolidated-invoice/${invoiceId}/bookings.csv`, {
      params: {
        ...(hostId ? { hostId } : {})
      },
      responseType: 'blob'
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getRetryPayment = id => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .get(`/payment/retry-payment/${id}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const listPendingOrders = () => {
  return httpClientCustom()
    .get('/external/pending-orders')
    .then(response => response)
    .catch(error => error.response);
};

export const getPendingOrder = orderId => {
  return httpClientCustom()
    .get(`/external/pending-orders/${orderId}`)
    .then(response => response)
    .catch(error => error.response);
};

export const updatePendingOrder = (orderId, body) => {
  return httpClientCustom()
    .put(`/external/pending-orders/${orderId}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response)
    .catch(error => error.response);
};

export const discardPendingOrder = orderId => {
  return httpClientCustom()
    .delete(`/external/pending-orders/${orderId}`)
    .then(response => response)
    .catch(error => error.response);
};

export const validateCheckoutVoucher = (code, priceId) => {
  return httpClientCustom()
    .get(`/external/vouchers/validate/${encodeURIComponent(code)}`, {
      params: priceId ? { priceId } : {}
    })
    .then(response => response)
    .catch(error => error.response);
};

export const cancelSubscription = id => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/cancel-subscription/${id}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const activeSubscription = id => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/resume-subscription/${id}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const resubScribeSubscription = (
  body = {
    projectId: String,
    priceId: String
  }
) => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/resubscribe`, body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const manageSubscription = (
  body = {
    projectId: String,
    customerId: String
  }
) => {
  return (
    // httpClientCustom(SernsoftUrl)
    httpClientCustom()
      .post(`/external/manage-subscription`, body)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      })
  );
};

export const loginByAccessToken = async body => {
  try {
    const response = await httpClientCustom().post('/auth/login-by-access-token');

    // Check if response is successful
    if (response.status >= 200 && response.status < 300) {
      return {
        success: true,
        data: response.data,
        message: 'Login successful'
      };
    }

    return {
      success: false,
      data: null,
      message: (response.data && response.data.message) || 'Login failed'
    };
  } catch (error) {
    console.error('Login by access token error:', error);
    return {
      success: false,
      data: null,
      message: (error.response && error.response.data && error.response.data.message) || error.message || 'An error occurred during login'
    };
  }
};
////////////////////////////////////////////////////////////

export const useGetPaginatedWebhook = query => {
  const getPaginatedWebhook = async (key, query) => {
    return httpClient
      .get('/webhook/paginated', { params: query, timeout: 180000 })
      .then(res => res.data)
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('webhookLogs', getPaginatedWebhook, query);
};

export const useGetPaginatedEInvoiceUsers = (query, options = {}) => {
  const getPaginatedEInvoiceUsers = async (key, queryToFetch) => {
    return httpClient
      .get('/e-invoice/users/paginated', { params: queryToFetch })
      .then(res => res.data)
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('eInvoiceUsers', getPaginatedEInvoiceUsers, query, {
    ...options,
    postProcessFunc: data => ({
      eInvoiceUsers: data.users || [],
      totalCount: data.total || 0,
      summary: data.summary
    })
  });
};

export const fetchEInvoiceUsersCSV = query => {
  const params = {
    ...(query.filter && { filter: encodeURIComponent(JSON.stringify(query.filter)) }),
    ...(query.sort && { sort: encodeURIComponent(JSON.stringify(query.sort)) }),
    month: query.month,
    year: query.year
  };

  return httpClient
    .get('/e-invoice/users/csv', { params })
    .then(res => res.data)
    .catch(apiErrorHandler);
};

export const getEInvoiceSubUsers = ({ hostId, accountId } = {}) => {
  const params = {};
  if (hostId) params.hostId = hostId;
  if (accountId) params.accountId = accountId;
  return httpClient
    .get('/e-invoice/sub-users', { params })
    .then(response => response)
    .catch(error => error.response);
};

export const getEInvoiceSubUserOptions = ({ hostId, accountId } = {}) => {
  const params = {};
  if (hostId) params.hostId = hostId;
  if (accountId) params.accountId = accountId;
  return httpClient
    .get('/e-invoice/sub-users/options', { params })
    .then(response => response)
    .catch(error => error.response);
};

export const createEInvoiceSubUser = body => {
  return httpClient
    .post('/e-invoice/sub-users', body)
    .then(response => response)
    .catch(error => error.response);
};

export const deleteEInvoiceSubUser = (id, { hostId, accountId } = {}) => {
  const params = {};
  if (hostId) params.hostId = hostId;
  if (accountId) params.accountId = accountId;
  return httpClient
    .delete(`/e-invoice/sub-users/${id}`, { params })
    .then(response => response)
    .catch(error => error.response);
};
